import i18nFactory from '@yandex-int/i18n';
import classNames from 'classnames';
import { Button } from 'lego-on-react';
import * as React from 'react';

import { PHRASES_GENERATOR_MAX_GROUPS, PHRASES_GENERATOR_MIN_GROUPS } from '../../../constants';
import { Bem } from '../../../service/Bem/Bem';
import { TestBem } from '../../../service/TestBem';
import { PhrasesSelectorGeneratorGroupPhrases } from '../../../typings/phrases';
import { Shape2, Shape2Icon } from '../../Shape2/Shape2';
import { PhrasesSelectorGeneratorGroup } from '../PhrasesSelectorGeneratorGroup/PhrasesSelectorGeneratorGroup';

import './PhrasesSelectorGeneratorGroups.css';
import * as keyset from './PhrasesSelectorGeneratorGroups.i18n';

const i18n = i18nFactory(keyset);

const BLOCK = 'phrases-selector-generator-groups';

export interface PhrasesSelectorGeneratorGroupsProps {
    groups: Array<PhrasesSelectorGeneratorGroupPhrases>;
    generatedPhrasesCount: number;
    onGroupAdd: () => void;
    onGroupRemove: (groupIndex: number) => void;
    onGroupPhrasesChange: (groupIndex: number, phrases: PhrasesSelectorGeneratorGroupPhrases) => void;
}

export class PhrasesSelectorGeneratorGroups extends React.PureComponent<PhrasesSelectorGeneratorGroupsProps> {
    render() {
        const { groups, generatedPhrasesCount, onGroupRemove, onGroupPhrasesChange } = this.props;
        const canAddGroup = groups.length < PHRASES_GENERATOR_MAX_GROUPS;
        const canRemoveGroup = groups.length > PHRASES_GENERATOR_MIN_GROUPS;

        return (
            <div className={Bem.cls(BLOCK)}>
                <div className={Bem.cls(BLOCK, 'content')}>
                    {groups.map((phrases, index) => (
                        <PhrasesSelectorGeneratorGroup
                            key={index}
                            canRemoveGroup={canRemoveGroup}
                            index={index}
                            phrases={phrases}
                            onGroupRemove={onGroupRemove}
                            onPhrasesChange={onGroupPhrasesChange}
                        />
                    ))}
                    {canAddGroup && this.renderAddButton()}
                </div>
                <div className={Bem.cls(BLOCK, 'combinations-count')}>
                    {i18n('combinations-count', {
                        count: generatedPhrasesCount
                    })}
                </div>
            </div>
        );
    }

    private renderAddButton = () => {
        const { onGroupAdd } = this.props;

        return (
            <Button
                cls={classNames(Bem.cls(BLOCK, 'add-button'), TestBem.cls(BLOCK, 'add-button'))}
                size="n"
                theme="pseudo"
                tone="default"
                view="classic"
                pin="brick-brick"
                onClick={onGroupAdd}
            >
                <Shape2
                    hoverable={true}
                    icon={Shape2Icon.plus}
                    cls={Bem.cls(BLOCK, 'plus-icon')}
                    width={14}
                    height={14}
                />
                {i18n('add-group')}
            </Button>
        );
    };
}
